import { useMutation, useQueryClient } from '@tanstack/react-query';
import { roleApi } from '../api/roleApi';
import type { UpdateRoleRequest } from '../types/role';

/**
 * PATCH /api/eraf/roles/{id} — 역할 부분 갱신
 */
export function useUpdateRole(id: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateRoleRequest) => roleApi.update(id, body),
    onSuccess: (data) => {
      queryClient.setQueryData(['role-management', 'detail', id], data);
      void queryClient.invalidateQueries({ queryKey: ['role-management', 'list'] });
    },
  });
}
